import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=23bf2f4a&scoped=true&"
import script from "./Button.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Button.vue?vue&type=style&index=0&id=23bf2f4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bf2f4a",
  null
  
)

export default component.exports